import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7ccb00bedae7001480821e_1786647744540_711f3492/talent/src/app/seller/[id]/page.tsx");
